import React, { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import './tutorial.css'
import Hexapi from '../../utility/HexAPI/Hexapi';
import { showCustomSwal } from '../customswal/Customswal'
import Loader from '../loader/Loader';

const TutorialModal = ({ show, hide, userid, istutorial }) => {

    const [videoData, setVideoData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loadedImages, setLoadedImages] = useState({});
    const modalBodyRef = useRef(null);

    const youtubeTutorial = async () => {

        setLoading(true);

        const obj = {
            query: `[dbo].[HRApp_Droid_Proc_VideoTutorial_GetData] @UserID='{0}',@TutorialType='{1}'`,
            queryArr: [`${userid}`, `${istutorial}`]
        };

        try {
            const videoDataGet = await Hexapi(obj, () => youtubeTutorial());
            if (videoDataGet && videoDataGet[""][0] && videoDataGet[""][0]?.command === "0") {
                setVideoData([]);
                hide();
                showCustomSwal(videoDataGet?.[""]?.[0]?.msg);

            } else {

                setVideoData(videoDataGet[""] || []);
            }

        } catch (error) {

            console.error("Error fetching video data:", error.message);
            setError("Failed to load video data");

            if (error.message === "SQL Error occurred") {
                hide();
                showCustomSwal("Error occurred , please try again");
            }

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        youtubeTutorial();
        return () => setLoading(false);
    }, [userid, istutorial]);

    const getYoutubeThumbnail = (url) => {
        const match =
            url?.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([\w-]+)/) ||
            url?.match(/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([\w-]+)/);

        return match ? `https://img.youtube.com/vi/${match[1]}/mqdefault.jpg` : null;
    };

    const filteredVideos = videoData.filter((ele) =>
        ele.description?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Modal className='allmodalblur' centered show={show} onHide={hide}>

            <Modal.Header closeButton style={{ paddingBottom: "10px" }}>
                <Modal.Title>
                    <h6 style={{ color: '#23b8fb', fontSize: "20px" }}>
                        {loading ? "Tutorial" : "Select Video"}
                    </h6>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body
                ref={modalBodyRef}
                style={{
                    overflowX: "hidden",
                    padding: "20px",
                    paddingBottom: !loading && "0px",
                }}
                className='scrollable-content2'
            >

                {loading ? (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Loader variant='info' />
                    </div>
                ) : error ? (
                    <div style={{ color: 'red' }}>{error}</div>
                ) : (
                    <>
                        {filteredVideos.length === 0 ? (
                            <p style={{ textAlign: "center", color: "#888" }}>
                                No videos found.
                            </p>
                        ) : (
                            filteredVideos.map((ele, index) => {

                                const thumbnail = getYoutubeThumbnail(ele.url);

                                return (
                                    <div
                                        key={index}
                                        onClick={() => window.open(ele.url, "_blank")}
                                        style={{
                                            marginBottom: "20px",
                                            cursor: "pointer",
                                            display: "flex",
                                            gap: "20px",
                                            alignItems: "center"
                                        }}
                                    >

                                        {/* Thumbnail with Shimmer */}
                                        {thumbnail && (
                                            <div
                                                style={{
                                                    width: "130px",
                                                    height: "75px",
                                                    position: "relative",
                                                    flexShrink: 0,
                                                }}
                                            >

                                                {!loadedImages[index] && (
                                                    <div className="shimmer-thumb" />
                                                )}

                                                <img
                                                    src={thumbnail}
                                                    alt={ele.description}
                                                    onLoad={() =>
                                                        setLoadedImages(prev => ({
                                                            ...prev,
                                                            [index]: true
                                                        }))
                                                    }
                                                    style={{
                                                        width: "130px",
                                                        height: "75px",
                                                        borderRadius: "6px",
                                                        objectFit: "cover",
                                                        display: loadedImages[index] ? "block" : "none"
                                                    }}
                                                />
                                            </div>
                                        )}

                                        {/* Description */}
                                        <p
                                            className='eledes'
                                            style={{
                                                fontWeight: '400',
                                                marginBottom: "0"
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: ele.description
                                            }}
                                        />
                                    </div>
                                );
                            })
                        )}
                    </>
                )}

            </Modal.Body>
        </Modal>
    );
};

export default TutorialModal;